'use strict';

import controller from './documentoIdentidad.controller';
import template from './documentoIdentidad.html';
import './documentoIdentidad.scss';

const documentoIdentidadComponent = {
    bindings: {
        ngModel: '=',
        onlyCi: '@',
        conf: '<',
        url: '<',
        callcackSearch:'<',
        completo: '<',
        departamentos: '<'
    },
    controller,
    template
};

export default documentoIdentidadComponent;



// WEBPACK FOOTER //
// ./src/app/common/core/util/forms/documentoIdentidad/documentoIdentidad.component.js